"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiOrderResponseDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const billing_api_charge_response_dto_1 = require("../../../billing-api-charge/types/dtos/billing-api-charge-response.dto");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const swagger_1 = require("../../../../swagger-fake");
const billing_api_order_contractor_response_dto_1 = require("./billing-api-order-contractor-response.dto");
const billing_api_order_dto_1 = require("./billing-api-order.dto");
let BillingApiOrderResponseDto = class BillingApiOrderResponseDto extends billing_api_order_dto_1.BillingApiOrderAbstractDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id поставщика",
  format: "uuid"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiOrderResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата создания",
  format: "date-time"
}), (0, class_transformer_1.Expose)(), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), __metadata("design:type", Date)], BillingApiOrderResponseDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата обновления",
  format: "date-time"
}), (0, class_transformer_1.Expose)(), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), __metadata("design:type", Date)], BillingApiOrderResponseDto.prototype, "updatedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Контрагенты (доступно при использовании include-опций запроса)",
  type: () => billing_api_order_contractor_response_dto_1.BillingApiOrderContractorResponseDto,
  isArray: true,
  minItems: 1,
  nullable: true,
  required: false,
  example: null
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsArray)(), (0, class_validator_1.ArrayMinSize)(1), (0, class_validator_1.ValidateNested)({
  each: true
}), (0, class_transformer_1.Type)(() => billing_api_order_contractor_response_dto_1.BillingApiOrderContractorResponseDto), __metadata("design:type", Object)], BillingApiOrderResponseDto.prototype, "contractors", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Начисления в сделке (доступно при использовании include-опций запроса).`,
  type: () => billing_api_charge_response_dto_1.BillingApiChargeResponseDto,
  nullable: true,
  required: false,
  isArray: true,
  example: null
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsArray)(), (0, class_validator_1.ValidateNested)({
  each: true
}), (0, class_transformer_1.Type)(() => billing_api_charge_response_dto_1.BillingApiChargeResponseDto), __metadata("design:type", Object)], BillingApiOrderResponseDto.prototype, "charges", void 0);
BillingApiOrderResponseDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiOrderResponseDto);
exports.BillingApiOrderResponseDto = BillingApiOrderResponseDto;
